import { createReducer, on } from "@ngrx/store";
import { projectCreate, projectDelete, projectList, projectUpdate } from "./project.action";

export const INIT_STATE = {
  items: [],
};

export const reducerProject = createReducer(
  INIT_STATE,
  on(projectList, (state, { items }) => {
    return {
      ...state,
      items: [...items],
    };
  }),
  on(projectCreate, (state, { item }) => {
    return {
      ...state,
      items: [item, ...state.items],
    };
  }),
  on(projectUpdate, (state, { item }) => {
    let index = state.items.findIndex((o) => o.id === item.id);

    const items = [...state.items];

    if (index > -1) {
      items[index] = item;
    }

    return {
      ...state,
      items: items,
    };
  }),
  on(projectDelete, (state, { item }) => {
    let items = state.items.filter((o) => o.id !== item.id);

    return {
      ...state,
      items: items,
    };
  })
);
